import { render } from "./AccessModuleComponent.vue?vue&type=template&id=52434188&scoped=true"
import script from "./AccessModuleComponent.vue?vue&type=script&lang=js"
export * from "./AccessModuleComponent.vue?vue&type=script&lang=js"

import "./AccessModuleComponent.vue?vue&type=style&index=0&id=52434188&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52434188"],['__file',"src/views/h5/common/basedata/role/AccessModuleComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "52434188"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('52434188', __exports__)) {
    api.reload('52434188', __exports__)
  }
  
  module.hot.accept("./AccessModuleComponent.vue?vue&type=template&id=52434188&scoped=true", () => {
    api.rerender('52434188', render)
  })

}


export default __exports__